// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r0o4t","type":"styles_type__3ICub","choices":"styles_choices__2JIHS"};